<template>
    <rkm-overlay>
        <rkm-layout-body title="Cadastro domiciliar e territorial">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'atencao-basica-cadastro-domiciliar-create' })"
                    autorize="store-atencao-basica-cadastro-domiciliar"
                    color="primary"
                >
                    Cadastrar território
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/atencao-basica/cadastro-domiciliar/List'

export default {
    components: { List },
}
</script>